import React from 'react'
import { PixelAlert, PixelCurrency, colors } from 'pixel-base'
import styled, { css } from 'styled-components'

const InvoicesStats = ({ stats }) => {
  return (
    <StatsContainer>
      <StatsInnerContainer>
        <StyledPixelAlert variant="primary">
          <StatsItemTitle>Total Last 365 Days</StatsItemTitle>
          <StatsItems>
            <StatsItem>
              <PixelCurrency
                value={stats['total']['amount']}
                currency={'PKR'}
              />
              <StatsItemCount>{stats['total']['count']} Total</StatsItemCount>
            </StatsItem>
          </StatsItems>
        </StyledPixelAlert>
        <StyledPixelAlert variant="danger">
          <StatsItemTitle>UnPaid Last 365 Days</StatsItemTitle>
          <StatsItems>
            <StatsItem>
              <PixelCurrency value={stats['open']['amount']} currency={'PKR'} />
              <StatsItemCount>{stats['open']['count']} Unpaid</StatsItemCount>
            </StatsItem>
            <StatsItem>
              <PixelCurrency
                value={stats['overdue']['amount']}
                currency={'PKR'}
              />
              <StatsItemCount>
                {stats['overdue']['count']} Overdue
              </StatsItemCount>
            </StatsItem>
          </StatsItems>
        </StyledPixelAlert>
        <StyledPixelAlert variant="success" flexEnd>
          <StatsItemTitle>Paid</StatsItemTitle>
          <StatsItems>
            <StatsItem>
              <PixelCurrency
                value={stats['closed']['amount']}
                currency={'PKR'}
              />
              <StatsItemCount justify>
                {stats['closed']['count']} Closed
              </StatsItemCount>
            </StatsItem>
          </StatsItems>
        </StyledPixelAlert>
      </StatsInnerContainer>
    </StatsContainer>
  )
}

const StatsContainer = styled.div`
  width: 100%;
  padding: 10px;
  background: ${colors.white};
  border: 1px solid ${colors.grayBorderLight};
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`

const StatsInnerContainer = styled.div`
  width: 100%;

  min-height: 100px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  align-content: center;
`

const StatsItemTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${colors.black};
  margin: 0;
  margin-bottom: 5px;
`
const StatsItemCount = styled.div<{ justify?: boolean }>`
  font-size: 12px;
  font-weight: 300;
  color: ${colors.black};
  margin: 0;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.justify ? 'flex-end' : 'space-between')};
  align-items: center;
  align-content: center;
`
const StyledPixelAlert = styled(PixelAlert)<{ flexEnd?: boolean }>`
  border: 1px solid ${colors.grayBorderLight};
  border-radius: 5px;
  padding: 10px;
  width: 30%;
  margin: 0;

  ${(props) =>
    props.flexEnd &&
    css`
      text-align: right;
      ${StatsItems} {
        justify-content: flex-end;
      }
    `}
`
const StatsItems = styled.div`
  display: flex;
  font-size: 18px;
  justify-content: space-between;
`
const StatsItem = styled.div<{ big?: boolean }>`
  margin: 0;
`

const StatsCard = styled.div`
  background: ${colors.white};
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex: 1;
  margin: 0 10px;
`

const StatsTitle = styled.h3`
  color: ${colors.black};
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 600;
`

const StatsValue = styled.div`
  color: ${colors.black};
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
`

export default InvoicesStats
